import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Nested admin path redirector: /admin/<section>/<page> → /admin?view=<section>.<page>
 *
 * Phase 2 introduces canonical path-style admin URLs while preserving the
 * existing `?view=` query as the runtime contract. Both shapes resolve to
 * the same admin view, so existing deep links keep working.
 */
export const Route = createFileRoute("/admin/$")({
  beforeLoad: ({ params }) => {
    const splat = (params as { _splat?: string })._splat ?? "";
    const parts = splat.split("/").filter(Boolean);
    if (parts.length === 0) {
      throw redirect({ to: "/admin", search: {} });
    }
    const viewId = parts.length === 1 ? parts[0] : `${parts[0]}.${parts.slice(1).join("-")}`;
    throw redirect({ to: "/admin", search: { view: viewId } });
  },
  component: () => null,
});
